export const languages = {
	cs: 'Čeština',
	de: 'Deutsch',
	en: 'English',
	es: 'Español',
	fr: 'Français',
	it: 'Italiano',
	ja: '日本語',
	ko: '한국어',
	pt: 'Português',
	ru: 'Русский',
	zh: '中文'
};

export const SITE_LANGUAGES = Object.keys(languages);
export type Language = (typeof SITE_LANGUAGES)[number];
